import Stack from '@mui/material/Stack';
import { useGetCommissionsPlansAPI } from '../../../hooks/api/useCommissions';
import { CommissionPlansHeader } from './CommissionPlansHeader';
import { CommissionPlanContent } from './CommissionPlanContent';
import { DeletePlanDialog } from './DeletePlanDialog';

const CommissionPlans = () => {
  useGetCommissionsPlansAPI();

  return (
    <Stack spacing={3}>
      <CommissionPlansHeader />
      <CommissionPlanContent />
      <DeletePlanDialog />
    </Stack>
  );
};

export {
  CommissionPlans,
};
